import { render } from "./SearchIcon.vue?vue&type=template&id=2754b2be"
import script from "./SearchIcon.vue?vue&type=script&lang=js"
export * from "./SearchIcon.vue?vue&type=script&lang=js"
script.render = render

export default script